import styled from "styled-components";
import { borderRadius } from "../../../design-system/tokens/borders";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";

/** Figma "Progress Bar" row (6433:560630): track + value, 10px apart. */
export const Root = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[2.5]};
  width: 100%;
  min-width: 0;
`;

/**
 * The track owns the 10px height so an empty (0%) bar keeps its shape; Figma
 * lets the fill set it, which would collapse the track at 0. `overflow: hidden`
 * keeps the fill's rounded end inside the track.
 */
export const Track = styled.div<{ $size?: "md" | "sm" }>`
  flex: 1 1 0;
  min-width: 0;
  height: ${({ $size }) => ($size === "sm" ? "0.25rem" : "0.625rem")};
  overflow: hidden;
  border-radius: ${borderRadius.full};
  background: ${rawColors.grey[300]};
`;

export const Fill = styled.div<{ $value: number }>`
  width: ${({ $value }) => $value}%;
  height: 100%;
  border-radius: ${borderRadius.full};
  background: ${rawColors.primary[500]};
  transition: width 0.3s ease;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const ValueLabel = styled.span`
  flex-shrink: 0;
  white-space: nowrap;
  ${typographyMixin("body", 2)}
  color: ${rawColors.text.highEmphasis};
`;
